"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 * 
 * @param {function} [handler = (e) => {}]
 * @param {*} dependencies 
 * @returns 
 */
var useOutsideClick = function useOutsideClick() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (e) {};
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = arguments.length > 2 ? arguments[2] : undefined;
  // We use a ref to hold onto our handler.
  var callbackRef = (0, _react.useRef)(handler);
  /* 
    Update ref if handler changes.
    Because we're using a ref, we don't need to update the EventListener.
  */

  (0, _react.useEffect)(function () {
    callbackRef.current = handler;
  }, [handler]);

  var outsideClickHandler = function outsideClickHandler(e) {
    // We check if we have an event handler and a target ref set before running event handler.
    if (callbackRef.current && ref.current && !ref.current.contains(e.target)) {
      callbackRef.current(e);
    }
  };

  (0, _react.useEffect)(function () {
    var _document;

    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('click', outsideClickHandler);
    return function () {
      var _document2;

      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.removeEventListener('click', outsideClickHandler);
    };
  }, dependencies);
};

var _default = useOutsideClick;
exports["default"] = _default;